import React from "react";
import { poItemListingColumns, selectChargesColumn } from "./constant";
import styles from "./styles.module.scss";
import CustomTooltip from "views/pages/manage/common/customTooltip/CustomTooltip";
import { CheckBox } from 'views/pages/manage/unAssigned/collectPayment/selectCharges/components/Checkbox';

const TableHeader = ({ rows, grnType, handleSelectAll }) => {
  const hasSerialItems = rows?.some(row => Array.isArray(row.serialItem) && row.serialItem.length > 0);
  const allChecked = rows.length > 0 && rows.every((r) => r.isChecked);
  const someChecked = rows.some((r) => r.isChecked);
  return (
    <div className={`${styles["table-header"]} text-bold label-color pb-2 mt-4 mx-3`}>
      {poItemListingColumns.map((item) => {
        if (item.colKey === "serialItem" && !hasSerialItems) {
          return null; // skip rendering this header if no serial items
        }
        if (grnType?.value != "101" && item.colKey === "isChecked") {
          return null;
        }
        if (item.colKey === "isChecked") {
          return (
            <CheckBox
              key="select-all"
              handler={(checked) => handleSelectAll(checked)}
              isChecked={allChecked}
              indeterminate={!allChecked && someChecked}
              disabled={rows.length === 0}
            />
          );
        }
        return (
          <CustomTooltip key={item.label} title={item.hoverDescription}>
            <div>{item.label}</div>
          </CustomTooltip>
        );
      })}
    </div>
  );
};

export default TableHeader;
